import script from "./UpdateHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateHistory.vue?vue&type=script&setup=true&lang=js"

import "./UpdateHistory.vue?vue&type=style&index=0&id=6ea6a476&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ea6a476"]])

export default __exports__